module.exports = __webpack_public_path__ + "static/media/travel4.1eefef54.jpg";